<template lang="pug">
  #sl-tax-document-list
    r-table(
      no-data-text='Sin documentos de venta.'
      no-remove
      no-search
      ref='table'
      v-bind='tableProps'
      @detail='submitDetail'
      )
      template(
        slot='actions' 
        slot-scope='props'
        )
        r-btn-action(
          bottom
          icon
          color='info'
          :disabled='! props.item.can_change_accounting_sale'
          tooltip='Fecha Contable'
          @click='submitAccounting(props)'
          )
          v-icon update

    // FECHA CONTABLE
    r-dialog( 
      no-confirm 
      title='Modificar fecha contable'
      width='800'
      v-model='dialogs.accounting'
      )
      r-form(
        ref='form'
        submit-text='guardar'
        v-bind='formProps'
        v-model='selected'
        @submit='submitChangeAccounting'
        )

    // DETALLE
    r-dialog( 
      no-confirm 
      v-bind='detailProps'
      v-model='dialogs.detail'
      )
      sl-tax-document-detail( 
        v-model='selected'
        )
</template>

<script>
  //
  import { mapActions, mapState } from 'vuex'
  //
  import { RBtnAction, RDialog, RForm, RTable } from '@/components/reusable_components/next'
  import AccPurchaseSaleBookService from '@/services/api/accounting/AccPurchaseSaleBook'
  //
  import SlTaxDocumentModel from '@/models/Sale/SlTaxDocument'
  import SlTaxDocumentDetail from '@/views/Sale/SlTaxDocument/SlTaxDocumentDetail'
  import SlTaxDocumentFields from '@/views/Sale/SlTaxDocument/SlTaxDocumentFields'
  import SlTaxDocumentFilters from '@/views/Sale/SlTaxDocument/SlTaxDocumentFilters'
  import SlTaxDocumentHeaders from '@/views/Sale/SlTaxDocument/SlTaxDocumentHeaders'
  //
  export default {
    name: 'sl-tax-document-list',
    components: {
      RBtnAction,
      RDialog,
      RForm,
      RTable,
      SlTaxDocumentDetail,
    },
    computed: {

      /**
       * { function_description }
       *
       * @return     {Object}  { description_of_the_return_value }
       */
      changeAccountingData() {
        switch (this.selected.alias) {
          case 'FACTURA':
            return {
              accounting_date : this.selected.new_accounting_date,
              invoices        : [this.selected.id],
              debit_notes     : [],
              credit_notes    : [],
            }
          case 'ND':
            return {
              accounting_date : this.selected.new_accounting_date,
              invoices        : [],
              debit_notes     : [this.selected.id],
              credit_notes    : [],
            }
          case 'NC':
            return {
              accounting_date : this.selected.new_accounting_date,
              invoices        : [],
              debit_notes     : [],
              credit_notes    : [this.selected.id],
            }
        }
      },

      /**
       * { function_description }
       *
       * @return     {Object}  { description_of_the_return_value }
       */
      detailProps() {
        return {
          title: `Detalle de ${this.selected.type.toLowerCase()}`,
        }
      },

      /**
       * { function_description }
       *
       * @return     {Object}  { description_of_the_return_value }
       */
      formProps() {
        return {
          fields: SlTaxDocumentFields,
        }
      },

      /**
       * { function_description }
       *
       * @return     {Object}  { description_of_the_return_value }
       */
      tableProps() {
        return {
          filters: SlTaxDocumentFilters,
          headers: SlTaxDocumentHeaders,
          service: SlTaxDocumentModel,
        }
      },
    },
    data() {
      return {
        dialogs: {
          accounting: false,
          detail: false,
        },
        selected: {
          type: '',
        },
      }
    },
    methods: {

      /**
       * @description
       * { function_description }
       */
      refresh() {
        this.$refs.table.refresh()
      },

      /**
       * Shows the error.
       *
       * @param      {<type>}  error   The error
       */
      showError(error) {
        return this.showErrorSnackbar(error.response.data.message)
      },

      /**
       * Shows the success.
       *
       * @return     {<type>}  { description_of_the_return_value }
       */
      showSuccess() {
        return this.showSuccessSnackbar('Fecha contable modificada exitosamente.')
      },

      /**
       * { function_description }
       *
       * @param      {<type>}  event   The event
       */
      submitAccounting(event) {
        this.selected = event.item.reset()
        this.dialogs.accounting = true
      },

      /**
       * { function_description }
       */
      submitChangeAccounting() {
        this
          .wait(true)
          .then(this.toChangeAccounting)
          .then(this.wait)
      },

      /**
       * { function_description }
       *
       * @param      {<type>}  event   The event
       */
      submitDetail(event) {
        this.selected = event.item
        this.dialogs.detail = true
      },

      /**
       * Returns a change accounting representation of the object.
       *
       * @return     {<type>}  Change accounting representation of the object.
       */
      toChangeAccounting() {
        return AccPurchaseSaleBookService
          .changeSaleDocs(this.changeAccountingData)
          .then(this.showSuccess)
          .then(this.refresh)
          .catch(this.showError)
      },

      /**
       * { function_description }
       *
       * @param      {boolean}  [val=false]  The value
       * @return     {<type>}   { description_of_the_return_value }
       */
      wait(val = false) {
        return this
          .$refs
          .form
          .setWait(val)
      },
    },
    mounted() {
      this.setTitle('Documentos de venta')
      //this.$refs.table.order.index = 3
    },
  }
</script>
